import { formatMoney } from "../../lib/meetupPricing";

/**
 * Transparent partner + DHC breakdown (VAT shown as remitted, not DHC profit).
 */
export default function NaviPricingBreakdown({ pricing, compact = false }) {
  if (!pricing) return null;

  const vatPct = (pricing.taxRate * 100).toFixed(1);
  const platformPct = (pricing.platformFeePercent * 100).toFixed(0);

  if (compact) {
    return (
      <p className="text-xs text-slate-500 mt-2 leading-relaxed">
        Mansion platform {platformPct}%: {formatMoney(pricing.dhcPlatformFee)} · Booking ops:{" "}
        {formatMoney(pricing.bookingServiceFee)} · Card recovery:{" "}
        {formatMoney(pricing.paymentProcessingRecovery)} ·{" "}
        <span className="text-slate-400">VAT/GCT remitted ({vatPct}%): {formatMoney(pricing.vatRemitted)}</span>
      </p>
    );
  }

  return (
    <div className="mt-4 space-y-3 rounded-2xl border border-slate-200 bg-slate-50 p-4 text-sm">
      <p className="font-semibold text-slate-800">What the guest pays includes</p>
      <ul className="space-y-1.5 text-slate-600">
        <li className="flex justify-between gap-2">
          <span>Your payout (you keep)</span>
          <strong className="text-slate-900">{formatMoney(pricing.businessPayout)}</strong>
        </li>
        <li className="flex justify-between gap-2">
          <span>Mansion platform fee ({platformPct}%)</span>
          <span>{formatMoney(pricing.dhcPlatformFee)}</span>
        </li>
        <li className="flex justify-between gap-2">
          <span>Booking operations fee</span>
          <span>{formatMoney(pricing.bookingServiceFee)}</span>
        </li>
        <li className="flex justify-between gap-2">
          <span>Payment processing recovery</span>
          <span>{formatMoney(pricing.paymentProcessingRecovery)}</span>
        </li>
        <li className="flex justify-between gap-2 border-t border-slate-200 pt-2">
          <span className="text-slate-500">VAT/GCT remitted to government ({vatPct}%)</span>
          <span className="text-slate-500">{formatMoney(pricing.vatRemitted)}</span>
        </li>
        <li className="flex justify-between gap-2 font-semibold text-slate-900">
          <span>Guest pays (all-in)</span>
          <span>{formatMoney(pricing.totalPrice)}</span>
        </li>
      </ul>
      <p className="text-xs text-slate-500">
        VAT is not Mansion profit — we collect and remit it. Mansion gross on this booking is about{" "}
        <strong>{formatMoney(pricing.dhcGrossRevenue)}</strong> before card network costs (~
        {formatMoney(pricing.estimatedPaymentProcessorCost)}), net ~{" "}
        <strong>{formatMoney(pricing.dhcNetAfterProcessing)}</strong>.
      </p>
    </div>
  );
}
